import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import Blank from '../../../hoc/Blank/Blank';
import Table from '../../../components/UI/Table/Table';
import Filter from '../../../components/Filter/Filter';
import Spinner from '../../../components/UI/Spinner/Spinner';
import SalesSummary from '../../../components/Order/SalesSummary/SalesSummary';
import Modal from '../../../components/UI/Modal/Modal';
import DeleteWarningModal from '../../../components/SuccessModals/DeleteWarningModal/DeleteWarningModal';
import * as actions from '../../../store/actions/index';
import 'react-toastify/dist/ReactToastify.min.css';
import { ToastContainer, toast } from 'react-toastify';
import Button from '../../../components/UI/Button/Button';

let deleting = false;
let orderId = 0;
class AdminOrders extends Component {
 
  state = {
    addOrder:false,
    showEditOrder: false,
    showSuccess: false,
    orderId: 0,
    editOrder: null,
    updated: false,
    delete: false,
    filter: '',
    sort: 'orderId',
    sortDirection: 'ascending',
    result: null,
    filteredUserId: 0
  }

  constructor(props) {
    super(props);
    if (this.props.filteredUserId)
    {
      this.state.filteredUserId = this.props.filteredUserId;
    }
    else {
      this.state.filteredUserId = 0;
    }
    this.setSort = this.setSort.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.onGetSalesSummary(false);
    this.props.onFetchOrders();
    this.props.onGetScouts();

  }

  componentDidUpdate(prevProps) {
    if (this.props.result != "0" && this.props.result != '') {
      let message = "The order was successfully added.";
      if (this.props.result == "updated") {
        message = "The order was successfully updated.";
      }
      if (!this.state.result || this.state.result != this.props.result) {
        this.setState({ result: this.props.result });
        toast(message);
      }
    }
  }

  setSort(key) {
    if (key !== this.state.sort) {
      this.setState({ sort: key, sortDirection: "ascending" })
    }
    else if (this.state.sortDirection == 'ascending') {
      this.setState({ sortDirection: 'descending' });
    }
    else {
      this.setState({ sortDirection: 'ascending' });
    }
  }

  deleteHandler = (e,oid) => {
    this.setState({ delete: true, orderId: oid });
    deleting = true;
    orderId  = oid
  }

  cancelDeleteHandler = () => {
    this.setState({ showEditOrder: false }, () => {
      this.setState({ delete: false })
    });
    deleting = false;
  }

  confirmDeleteHandler = () => {
    this.setState({ showEditOrder: false }, () => {
      this.setState({ delete: false });
    });
    deleting = false;

    this.props.onDeleteOrder(orderId);
  }

  addOrder = () => {
    this.props.history.push('/adminAddOrder');
  }

  filterChanged = (filter) => {
    this.setState({ filter: filter });
  }

  showOrder = (e) => {
    if (!deleting) {
      this.setState({ result: "" });
      let oid = e.currentTarget.getAttribute('oid');
      
      this.props.history.push('/adminEditOrder?' + oid + '&' + this.props.filteredUserId);
    }
  }


  render() {
    let addOrd = null;
        if (this.state.addOrder) {
            addOrd = <Redirect to='adminAddOrder?0' />
        }
    if (!this.props.loading && this.props.orders) {
      var data = [];
      let pl = "15px";
      let fifty = "50px";
      let oneFifty = "150px";
      let seventyFive = "75px";
      let oneHundred = "100px";
      if (window.innerWidth < 500) {
        pl = "5px";
        fifty = "40px";
        oneFifty = "100px";
        seventyFive = "50px";
        oneHundred = "75px";
      }
      let orders = this.props.orders.sort((a, b) => {
        let txta;
        let txtb;
        if (this.state.sort == 'orderId') {
          txta = a.orderId;
          txtb = b.orderId;
        }
        else if (this.state.sort == 'scout') {
          txta = a.scout.toLowerCase();
          txtb = b.scout.toLowerCase();
        }
        else if (this.state.sort == 'name') {
          txta = a.name.toLowerCase();
          txtb = b.name.toLowerCase();
        }
        else if (this.state.sort == 'address') {
          txta = a.address.toLowerCase();
          txtb = b.address.toLowerCase();
        }
        else if (this.state.sort == 'notes') {
          txta = a.notes.toLowerCase();
          txtb = b.notes.toLowerCase();
        }
        else if (this.state.sort == 'paid') {
          txta = a.paymentStatus.toLowerCase();
          txtb = b.paymentStatus.toLowerCase();
        }
        else if (this.state.sort == 'status') {
          txta = a.status.toLowerCase();
          txtb = b.status.toLowerCase();
        }
        if (this.state.sortDirection == 'ascending') {
          return (txta > txtb) ? 1 : (txta < txtb) ? -1 : 0;
        }
        else {
          return (txta > txtb) ? -1 : (txta < txtb) ? 1 : 0;
        }
      });

      let i = -1;
      for (let k in orders) {
        let show = false;
        let order = orders[k];

        if (this.state.filter == '' && this.props.filteredUserId== 0) {
          show = true;
        }
        else if (this.props.filteredUserId > 0) {
           if (order.userId == this.props.filteredUserId) {
              show = true
           }
        }
        else {
          let filter = this.state.filter.toString().toLowerCase();
          if (filter == 'unpaid') {
            if (order.paymentStatus == 'unpaid') {
              show = true;
            }
          }
          else if (filter == 'paid') {
            if (order.paymentStatus == 'paid') {
              show = true;
            }
          }
          else if (filter == 'pickup') {
            if (order.deliveryType == 'pickup') {
              show = true;
            }
          }
          else {
            if (order.name.toString().toLowerCase().indexOf(this.state.filter) > -1) {
              show = true;
            }

            if (order.address.toString().toLowerCase().indexOf(this.state.filter) > -1) {
              show = true;
            }

            if (order.scout.toString().toLowerCase().indexOf(this.state.filter) > -1) {
              show = true;
            }

            if (order.notes.toString().toLowerCase().indexOf(this.state.filter) > -1) {
              show = true;
            }
          }
        }

        if (show) {
          i = i + 1;
          data.push({
            oid: order.orderId, data: [
              {
                oid: order.orderId,
                type: 'button',
                label: 'Delete',
                style: { paddingleft: pl, textAlign: 'right' },
                full: true
            },  
            {
              value: order.orderId,
              style: { paddingLeft: pl, width: seventyFive },
              full: false
            },
            {
              value: order.scout,
              style: { width: oneFifty, paddingLeft: pl },
              full: false
            },
            {
              value: order.name,
              style: { paddingLeft: pl },
              full: false
            },
            {
              value: order.address + ',' + order.city,
              style: { paddingLeft: pl },
              full: true
            },
            {
              value: order.phone,
              style: { paddingLeft: pl },
              full: true
            },
            {
              value: order.email,
              style: { paddingLeft: pl },
              full: true
            },
            {
              value: order.notes,
              style: {paddignleft:pl}
            },
            {
              value: order.deliveryType,
              style: {paddignleft:pl}
            }
            
            ]
          }
          )

          if (this.props.mulchYear.sellHardwood) {
            data[i].data.push(
              {
                value: order.hardwoodBags,
                style: { paddingLeft: pl },
                full: false
              }
            );
          }
          if (this.props.mulchYear.sellCedar) {
            data[i].data.push(
              {
                value: order.cedarBags,
                style: {paddingLeft: pl },
                full: false
              }    
            );
          }
          if (this.props.mulchYear.sellBlack) {
            data[i].data.push(
              {
                value: order.blackBags,
                style: { paddingLeft: pl },
                full: false
              }
            );
          }
          if (this.props.mulchYear.sellRed) {
            data[i].data.push(
              {
                value: order.redBags,
                style: { paddingLeft: pl },
                full: false
              }
            );
          }

          data[i].data.push (
          {
            value: order.paymentStatus,
            style: { paddingLeft: pl },
            full: true
          },
          {
            value: order.status,
            style: { paddingLeft: pl },
            full: true
          },
          {
            value:"",
            style:{paddingLeft: pl}
          }   
                 
          )
        }
      }


      var header = [        
        {
          name: "",
          style: {  paddingLeft: pl },
          full: false
        },
        {
        name: "Order",
        sort: "orderId",
        style: { paddingLeft: pl}
      },
      {
        name: "Scout",
        sort: "scout",
        style: {  paddingLeft: pl }
      },
      {
        name: "Name",
        sort: "name",
        style: {  paddingLeft: pl }
      },
      {
        name: "Address",
        sort: "address",
        style: {  paddingLeft: pl },
        full: true
      },
      {
        name: "Phone",
        sort: "",
        style: {  paddingLeft: pl },
        full: true
      },
      {
        name: "Email",
        sort: "",
        style: {  paddingLeft: pl },
        full: true
      },
      {
        name:"Notes",
        sort: "notes",
        style: {paddingLeft:pl}
      },
      {
        name:"Del Type",
        style: {paddingLeft:pl}
      }
    ];

    if (this.props.mulchYear.sellHardwood) {
      header.push(
      {
        name: "Hwd",
        style: { paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellCedar) {
      header.push(
      {
        name: "Cdr",
        style: {  paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellBlack) {
      header.push(
      {
        name: "Blk",
        style: {  paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellRed) {
      header.push(
      {
        name: "Red",
        style: {  paddingLeft: pl }
      })
    }

    header.push(
      {
        name: "Paid",
        sort: "paid",
        style: {  paddingLeft: pl },
        full: true
      },
      {
        name: "Status",
        sort: "status",
        style: {  paddingLeft: pl },
        full: true
      },
      {
        name: "",
        sort: "",
        style: {  paddingLeft: pl },
        full: true
      }      
    )

      let modalDelete = null;
      if (this.state.delete) {
        modalDelete = <DeleteWarningModal delete={this.confirmDeleteHandler} cancel={this.cancelDeleteHandler}></DeleteWarningModal>
      }

      let salesSummary = null;
      if (this.props.summary) {
        salesSummary = <SalesSummary />
      }

      return (

        <Blank>
          <ToastContainer autoClose={3000} />
          {salesSummary}
          <Button 
                    btnType="Success"
                    clicked={this.addOrder}>ADD NEW ORDER</Button>
          <Filter filterChanged={this.filterChanged} value={this.state.filter} />
          <Table header={header} data={data} onSort={this.setSort} onClick={this.deleteHandler} editPopupHandler={this.showOrder}></Table>
          <Modal show={this.state.delete} modalClosed={this.cancelDeleteHandler}>
            {modalDelete}
          </Modal>

        </Blank>
      );
    }
    else {
      return (
        <div>
          <Spinner />
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    mulchYear: state.orders.mulchYear,
    summary: state.orders.salesSummary,
    orders: state.orders.orders,
    loading: state.orders.loading,
    submitted: state.orders.submitted,
    scoutsLastGot: state.orders.scoutsLastGot
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onDeleteOrder: (orderId) => dispatch(actions.deleteOrder(orderId)),
    onGetScouts: () => dispatch(actions.getScouts()),
    onFetchOrders: () => dispatch(actions.fetchOrders()),
    onGetSalesSummary: (forUSer) => dispatch(actions.getSalesSummary(forUSer))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminOrders);


// WEBPACK FOOTER //
// ./src/containers/Orders/AdminOrders/AdminOrders.js